module.exports = __webpack_public_path__ + "static/img/1-06.275a8ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/1-06.png
// module id = 207
// module chunks = 0